import { Component, input, inject } from '@angular/core';
import { Program } from '@program/shared/program.model';
import { Organization } from '@shared/models/organization/organization.model';
import { User } from '@user/user.model';
import { UserService } from '@user/user.service';
import { ProgramApplication } from '@program/shared/program-application.model';

@Component({
  selector: 'oes-program-admin-message',
  templateUrl: './program-admin-message.component.html',
})
export class ProgramAdminMessageComponent {
  programApplication = input.required<ProgramApplication>();
  program = input.required<Program>();
  currentUser = input.required<User>();
  isEvaluationMessage = input<boolean>(false);

  readonly userService = inject(UserService);

  participantOrganization(): Organization {
    return this.programApplication()?.participant;
  }

  // NOTE: PROGRAM_PARTICIPANT_MESSAGES files are tagged AND queried by this id (see
  // message-window.component). This panel deliberately uses the specific application passed in,
  // which may be a non-stage-0 stage. The program-wide messaging area
  // (message-developer / message-list-investor) instead resolves to the participant's STAGE-0
  // application, so files tagged here under a non-stage-0 application will not appear there, and
  // vice versa. This is currently assumed intentional (per-stage / evaluation thread). If these
  // two surfaces are meant to share a single conversation, align this to the stage-0 application
  // the same way message-developer.component does.
  stageOneApplicationId(): string {
    return this.programApplication()?.id;
  }
}
